<template>
  <div class="tips-mask" v-show="isShowMask">
    <div v-if="showType == 1  " class="tips">
      <div class="img-tip">
        <img class="up-img" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/h5/up_white.png" alt="">
      </div>
      <div class="color-white tac fs">①点击右上角··· ②选择在浏览器打开</div>
    </div>
    <div class="app-store" v-if="showType =='0'">
      <div class="app-name color-white tac fs">前往{{isIos ? 'App Store' : '应用商店'}}搜索“{{isIos ? dataInfo.iosSearchKeyword : dataInfo.androidSearchKeyword}}”</div>
    </div>
    <div class="btn color-white bgc tac" @click="know">我知道了</div>
  </div>
</template>

<script>
export default {
  props:{
    dataInfo: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      isShowMask: false,
      timer: null,
      opening: false,
      isIos:'',
    }

  },
  watch: {
    opening() {
      this.$emit('sendStatus', this.opening)
    },
  },
  mounted() {
    const that = this
    document.addEventListener("visibilitychange", function () {
      if (that.timer) {
        that.opening = false
        clearTimeout(that.timer)
      }
    }, false);

    const agent = navigator.userAgent;
    this.isIos = !!agent.match(/\Mac OS X/)
  },
  methods: {
    browserOpenApp(item) {
      console.log(this.isWeChat, 'this.isWeChat-----')
      // if(!this.isWeChat && !this.isAlipay && item.appSchema){
      //   window.location = `${item.appSchema}`
      //   return
      // }
      // if(this.isIos && this.isWeChat && this.showType == 1){
      //   this.isShowMask = false
      //   return
      // }
      if(this.isWeChat || this.isAlipay ) {
        this.isShowMask = true
        return
      }
      if(this.showType == 0) {
         this.isShowMask = true
      }
      const agent = navigator.userAgent;
      const isIos = !!agent.match(/\Mac OS X/)
      let that = this
      that.opening = true
      if (!isIos) { //  安卓处理

        let ifr = document.createElement('iframe');
        if(item.appSchema) {
            ifr.src = `${item.appSchema}`
            ifr.style.display = 'none';
            document.body.appendChild(ifr);
        }

        if(this.showType == 0) {
          that.opening = false
          return
        }
        that.timer = window.setTimeout(function () {  //  未安装的情况
          that.opening = false
          if(item.appSchema) {
            document.body.removeChild(ifr);
          }
          //  提示下载
          window.location = item.androidDownloadLink;
          // let r = confirm("未安装APP? 是否下载")
          // if (r) {
          //   window.location = that.$store.state.downloadUrl;
          // }
        }, 2000)
      } else {  //  IOS处理
        if(item.appSchema){
          window.location = `${item.appSchema}`
        }
        if(this.showType == 0) {
          that.opening = false
          return
        }
        that.timer = setTimeout(function () { //  未安装的情况
          that.opening = false
          //  跳转app store
          window.location = item.iosDownloadLink
          // let r = confirm("未安装APP? 是否去App store查看")
          // if (r) {
          //   window.location = 'itms-apps://itunes.apple.com/app/id1567163324'
          // }
        }, 2000);
      }
    },

    know(){
      this.isShowMask = false;
    }
  },
  components: {

  },
  computed: {
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      let arr = ua.match(/MicroMessenger/i) || []
      return arr.includes("micromessenger")
    },
    isAlipay() {
      const ua = navigator.userAgent.toLowerCase();
      let arr = ua.match(/AlipayClient/i) || []
      return arr.includes("alipayclient")
    },
    showType(){
      if(!this.isIos) {
        return this.dataInfo.androidDownloadType || '0'
      }
      if(this.isIos) {
        return this.dataInfo.iosDownloadType || "0"
      }
    }
  },
}
</script>

<style scoped lang='less'>
.tips-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100vw;
  background: rgba(#000000, 0.7)
}
.tips{
  width: 100vw;
  margin: 10px 0 0 0;
}
.btn{
  margin: 30px 28% 25px 28%;
  padding: 16px;
  border-radius: 38px;
  font-size: 36px;
}
.img-tip{
  text-align:right;
  .up-img{
    width: 50px;
    margin-right: 30px;
  }
}
.app-store{
  margin-top: 20px;
}
.app-name{
  margin: 0 30px;
  word-break:break-all;
}
.tac{
  text-align: center;
}
.color-white{
  color:#fff
}
.bgc{
  background-color: #F23E7E;
}
.flex{
  display: flex;
}
.mb{
  margin-bottom: 50px;
}
.wsn{
  white-space:nowrap;
}
.fs{
  font-size:38px;
}
</style>
